import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { TextBox, TextBoxProps } from "../core/components/textBox";
import { DropDownList } from "../core/components/dropDownList";
import { FieldInstance } from "../core/components/field";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { Dialog, DialogProps } from "../core/components/dialog";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect";
import { Button } from "../core/components/button";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { CheckBox } from "../core/components/checkBox";
import { ContextGeneralSettingsApp } from "./generalSettings";
import React from "react"

export default class EditActivity extends React.Component<EditNachschlagProps, EditNachschlagState> {
    private translations = null;
    private options: any = null;
    private factory = ComponentHelper.createFactory();
    private mainGroupDepended: boolean;
    private fullLoaded: boolean;
    private userLanguage: number;
    private tabId: number;
    private nextId: number;
    private hardLock: boolean;
    private allMainGroups: KeyValue[];
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.getGridData();

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this.checkData()) {
                        this.save();
                    } else {
                        DialogHelper.alert(this.translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }

                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 750
    };

    constructor(props: EditNachschlagProps) {
        super(props);
        this.mainGroupDepended = false;
        this.state = {
            gridData: [], searchedOGrNr: null, dialogOpen: false, currentItem: null, buttons: { addToAllMainGroups: false, delete: false }
        };
    }

    private checkData = () => {
        if (this.mainGroupDepended) {
            return !Helper.isNullOrEmpty(this.state.currentItem.Name) && (this.state.currentItem.MainGroups.length > 0);
        } else {
            return !Helper.isNullOrEmpty(this.state.currentItem.Name);
        }
    }

    private getGridData = () => {
        let url = "Nachschlag/Get?TabId=" + this.tabId;
        if (Helper.hasValue(this.state.searchedOGrNr)) {
            url += "&MainGroup=" + this.state.searchedOGrNr;
        }
        HTTPService.get<JsonResultClass<Nachschlag[]>>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.userLanguage = result.AdditionalData["Userlanguage"];
                    this.mainGroupDepended = result.AdditionalData["MainGroupDependend"];
                    this.nextId = result.AdditionalData["NextId"]
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private save = () => {
        let url = "Nachschlag/Save";
        HTTPService.post<JsonResultClass>(url, { TabId: this.tabId, model: this.state.currentItem }).then(result => {
            switch (result.Code) {
                case 0:
                    this.getGridData();
                    break;
                case 1:
                    NotificationHelper.showErrorMessage(result.Message);
                    break;
                case 2:
                    this.getGridData();
                    NotificationHelper.showWarningMessage(result.Message);
                    break;
            }
        });
    }

    private createSearchFilter = () => {
        if (this.fullLoaded && this.mainGroupDepended && !this.hardLock) {
            let props = this.factory.getDefaultDropDownProps();
            props.value = this.state.searchedOGrNr;
            props.field.dataSourceUrl = "Nachschlag/GetMainGroups";
            props.field.dataTextField = "Value";
            props.field.dataValueField = "Key";
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                let oGrNr: number = null;
                if (typeof (dataItem.Key) === "number") {
                    oGrNr = dataItem.Key;
                }
                this.setState({ searchedOGrNr: oGrNr }, () => { this.getGridData() });
            }
            props.onDataLoaded = (field: { model: string }, data: any) => {
            }
            return (
                <FieldInstance label={this.translations["WebCRM.Administration.Obergruppe"]} noHover={true}>
                    <DropDownList {...props} />
                </FieldInstance>
            );
        } else {
            return (<></>);
        }
    }

    private createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this.dialogProps} open={this.state.dialogOpen} >
                        <FullHeightContainer>
                            {this.createTextBox()}
                            {this.createMultiSelect()}
                            {this.createFeldInt()}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private createTextBox = () => {
        let props: TextBoxProps = this.factory.getDefaultTextBoxProps();
        props.value = Helper.getValueOrDefault(this.state.currentItem.Name, "");
        props.field.maxLength = 33;
        props.onChange = (field: { model: string }, value: any) => {
            let item = this.state.currentItem;
            item.Name = value;
            this.setState({ currentItem: item });
        }
        const link = this.createLink();
        return (
            <FieldInstance label={this.props.context.translations["Standard.Name"] + "*"} noHover={true}>
                <TextBox {...props} />
                {link}
            </FieldInstance>
        );
    }

    private createLink = () => {
        if (!this.state.currentItem.IsNew) {
            return (
                <>
                    <TranslationLink
                        values={this.state.currentItem.Translations}
                        onOkClick={this.handleTranslationsChange}
                        currentLanguage={this.userLanguage}
                    />
                </>
            );
        } else {
            return (<></>);
        }
    }

    private handleTranslationsChange = (translations: KeyValue[]) => {
        let item = this.state.currentItem;
        item.Translations = translations;
        this.setState({ currentItem: item });
    }

    private createMultiSelect = () => {
        if (this.mainGroupDepended && !this.hardLock) {
            let props = this.factory.getDefaultMultiSelectProps();
            props.value = this.state.currentItem.MainGroups;
            props.field.dataSourceUrl = "Nachschlag/GetMainGroups";
            props.field.dataTextField = "Value";
            props.field.dataValueField = "Key";
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                let item = this.state.currentItem;
                item.MainGroups = value;
                this.setState({ currentItem: item });
            }
            props.onDataLoaded = (field: { model: string }, data: KeyValue[]) => {
                this.allMainGroups = data;
            }
            return (
                <FieldInstance label={this.translations["WebCRM.Administration.Obergruppe"] + "*"} noHover={true}>
                    <div style={{ display:"flex" }}>
                        <MultiSelect {...props} />
                        {this.createButton()}
                    </div>
                </FieldInstance>
            );
        } else {
            return (<></>);
        }
    }

    private createButton = () => {
        return (
            <div style={{ marginLeft: "10px" }}>
                <Button iconName={"fas fa-share-all"} handleClick={this.handleButtonClick} buttonStyle={{ height: "29px" }} title={this.translations["WebSMS.GeneralSettings.Nachschlag.AssignToAllMainGroups"]} />
            </div>);
    }

    private createFeldInt = () => {
        if (Helper.hasValue(this.props.field.props.fields)) {
            const field = this.props.field.props.fields.find(f => f.field.toLowerCase() == "feldint");
            if (Helper.hasValue(field)) {
                const onValueChange = (value: number) => {
                    let baseValue = JSON.parse(JSON.stringify(value));
                    let func: (value) => any = null;
                    if (!Helper.isNullOrEmpty(field.onChange)) {
                        try {
                            func = eval(field.onChange);
                            value = func(value);
                        } catch (ex) {
                            value = baseValue;
                            console.error(ex);
                        }
                    }
                    let item = this.state.currentItem;
                    item.FeldInt = value;
                    this.setState({ currentItem: item });
                }
                const renderAsCheckBox = Helper.hasValue(field.renderAsCheckBox) && field.renderAsCheckBox;
                if (renderAsCheckBox) {
                    let props = this.factory.getDefaultCheckBoxProps();
                    props.value = this.state.currentItem.FeldInt == 1;
                    props.onChange = (_, checked: boolean) => {
                        let value = checked ? 1 : 0;
                        onValueChange(value);
                    }
                    return (
                        <FieldInstance label={field.name} noHover={true}>
                            <CheckBox {...props} />
                        </FieldInstance>
                    )
                
                } else {
                    let props = this.factory.getDefaultNumericTextBoxProps();
                    props.value = this.state.currentItem.FeldInt;
                    props.onChange = (_, value) => {
                        onValueChange(value);
                    }

                    return (
                        <FieldInstance label={field.name} noHover={true}>
                            <IsNumericTextBox {...props} />
                        </FieldInstance>
                    )
                }
            }
        }
        return null;
    }

    private handleButtonClick = () => {
        let item = this.state.currentItem;
        item.MainGroups = this.allMainGroups;
        this.setState({ currentItem: item })
    }

    private delete = (dataItem: any) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                let url = "Nachschlag/Delete";
                HTTPService.post<JsonResultClass>(url, { TabId: this.tabId, model: dataItem }).then(result => {
                    switch (result.Code) {
                        case 0:
                            this.getGridData();
                            break;
                        case 1:
                            NotificationHelper.showErrorMessage(result.Message);
                            break;
                        case 2:
                            this.getGridData();
                            NotificationHelper.showWarningMessage(result.Message);
                            break;
                    }
                });
            }
        });
    }

    private openDialog = (dataItem: Nachschlag = null) => {
        if (!Helper.hasValue(dataItem)) {
            dataItem = {
                Id: this.nextId,
                MainGroups: (this.hardLock ? [{ Key: this.state.searchedOGrNr, Value: "" }] : []),
                Name: "",
                HasAllMainGroups: false,
                Translations: [],
                IsNew: true,
                IsDeletable: true,
                FeldInt: null
            };
        } else {
            let filtered = this.state.gridData.filter(f => f.Id === dataItem.Id);
            if (filtered.length == 1)
                dataItem = filtered[0];
        }
        this.setState({ dialogOpen: true, currentItem: dataItem })
    }

    private addToAllMainGroups = (dataItem: Nachschlag) => {
        DialogHelper.confirm(this.translations["WebSMS.GeneralSettings.Nachschlag.SureToAssignToAllMainGroups"]).then(isOk => {
            if (isOk) {
                let url = "Nachschlag/AddToAllMainGroups";
                HTTPService.post<JsonResultClass>(url, { TabId: this.tabId, model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this.getGridData();
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });
    }

    private removeMainGroup = (dataItem: Nachschlag) => {
        let text: string = "";
        if (dataItem.MainGroups.length == 1) {
            text = this.translations["WebSMS.GeneralSettings.Nachschlag.LastValue"]
        } else {
            text = this.translations["WebSMS.GeneralSettings.Nachschlag.SureForRemoveMainGroup"];
        }
        DialogHelper.confirm(text).then(isOk => {
            if (isOk) {
                let url = "Nachschlag/RemoveFromMainGroup";
                HTTPService.post<JsonResultClass>(url, { TabId: this.tabId, OGrNr: this.state.searchedOGrNr, model: dataItem }).then(result => {
                    if (result.Code == 0) {
                        this.getGridData();
                        $(window).trigger("nachschlagGridDataChange_" + this.tabId, { gridDataChanged: true});
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
            }
        });

    }

    private createGrid = () => {
        if (this.fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.buttons.delete });

            const customButtons: Array<GridCustomToolBarButton> = [];
            if (this.mainGroupDepended && !this.hardLock) {
                customButtons.push({
                    id: "allMainGroups", enabled: this.state.buttons.addToAllMainGroups, caption: this.translations["WebSMS.GeneralSettings.Nachschlag.AssignToAllMainGroups"], autoEnabledOnRecordSelected: true, iconClass: "fas fa-share-all"
                });
            } else if (this.mainGroupDepended && this.hardLock) {
                customButtons.push({
                    id: "removeFromMainGroup", enabled: true, caption: this.translations["WebSMS.GeneralSettings.Nachschlag.RemoveFromMainGroup"], autoEnabledOnRecordSelected: true, iconClass: "fas fa-reply"
                });
            }

            let gridId = "generalSettings_NachschlagGrid_" + this.props.field.props.tabId + (this.props.field.props.hardLock ? "hl":"");
            let grid = (
                <Grid data={this.state.gridData} options={this.options} id={gridId}
                    onSelectionChanged={this.handleSelectedChange}
                    standardButtons={standardButtons} customButtons={customButtons}
                    onClickStandardButton={this.handleClickStandardButton} onClickCustomButton={this.handleClickCustomButton}
                    selectFilter={this.state.currentItem == null ? null : this.state.currentItem.Name} />
            );
            return (
                <div style={{ height: "300px" }}>
                    {grid}
                </div>
            )
        } else {
            return (<></>);
        }
    }

    private handleSelectedChange = (dataItem: Nachschlag) => {
        if (Helper.hasValue(dataItem))
            this.setState({ buttons: { delete: dataItem.IsDeletable, addToAllMainGroups: !dataItem.HasAllMainGroups } });
        else
            this.setState({ buttons: { delete: false, addToAllMainGroups: false } });
    }

    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Nachschlag) => {
        switch (type) {
            case (ToolBarStandardButtonType.EDIT):
                this.openDialog(dataItem)
                break;
            case (ToolBarStandardButtonType.NEW):
                this.openDialog()
                break;
            case (ToolBarStandardButtonType.DELETE):
                this.delete(dataItem);
                break;
        }
    }

    private handleClickCustomButton = (id: string, dataItem: Nachschlag, dataItems: Array<any>) => {
        switch (id) {
            case ("allMainGroups"):
                this.addToAllMainGroups(dataItem);
                break;
            case ("removeFromMainGroup"):
                this.removeMainGroup(dataItem)
                break;
        }
    }

    componentDidMount() {
        this.tabId = this.props.field.props.tabId;            
        this.loadTranslations();
        this.setEvents();
        this.hardLock = Helper.getValueOrDefault(this.props.field.props.hardLock, false);
        if (this.hardLock) {
            this.setState({ searchedOGrNr: this.props.entity.OGrNr }, () => { this.getGridData() });
        } else {
            this.getGridData();
        }
    }

    private loadTranslations = () => {
        Helper.getTranslations(["Sprachen.Sprache", "WebCRM.Administration.Obergruppe", "Standard.Name", "Standard.Key",
            "Standard.PflichtfeldAllgemein", "WebSMS.GeneralSettings.Nachschlag.RemoveFromMainGroup",
            "WebSMS.GeneralSettings.Nachschlag.AssignToAllMainGroups", "WebSMS.GeneralSettings.Nachschlag.SureToAssignToAllMainGroups",
            "WebSMS.GeneralSettings.Nachschlag.LastValue", "WebSMS.GeneralSettings.Nachschlag.SureForRemoveMainGroup"])
            .then((result) => {
                this.translations = result.Data;
                this.setState({}, () => { this.setGridOptions() });
            });
    }

    private setGridOptions = () => {
        let columns: Columnn[] = [
            {
                field: "Id",
                title: this.translations["Standard.Key"],
                width: 40
            },
            {
                field: "Name",
                title: this.translations["Standard.Name"],
                width: 80
            }
        ];
        let field: Field = null;
        if (Helper.hasValue(this.props.field.props) && Helper.hasValue(this.props.field.props.fields)) {
            field = this.props.field.props.fields.find(f => f.field.toLowerCase() === "feldint");
        }
        if (Helper.hasValue(field)) {
            columns.push({
                field: "FeldInt",
                title: field.name,
                width: 80
            });
            if (Helper.hasValue(field.renderAsCheckBox) && field.renderAsCheckBox) {
                columns[2].template = "#if(data.FeldInt == 1) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#";
            }
        }
        let gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: true,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: columns
        }
        this.options = gridOptions;
        this.setState({});
    }

    private setEvents = () => {
        $(window).on("nachschlagGridDataChange_" + this.tabId, (e, d) => {
            if (d.gridDataChanged) {
                this.getGridData();
            }
        });
    }

    render() {
        this.fullLoaded = Helper.hasValue(this.translations) && Helper.hasValue(this.options) && Helper.hasValue(this.tabId);
        const searchFilter = this.createSearchFilter();
        const grid = this.createGrid();
        const dialog = this.createDialog();
        return (
            <>
                {searchFilter}
                {grid}
                {dialog}
            </>);
    }
};

class TranslationLink extends React.Component<TranslationLinkProps, TranslationLinkState>{
    private factory = ComponentHelper.createFactory();
    private translations: {} = null;
    private localStorageKey: string = "nachschlag_Languages";
    private currentLanguageSelection: Array<{ Language: number, Sprache: string }> = [];
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOkClick(this.state.values);
                },
                primary: true
            }
        ],
        afterClose: () => {
            Helper.saveDataToStorage(this.localStorageKey, this.currentLanguageSelection, false);
            this.setState({ dialogOpen: false });
        },
        width: 500

    };

    constructor(props: TranslationLinkProps) {
        super(props);
        this.localStorageKey += "_" + props.currentLanguage;
        let languages = Helper.loadDataFromStorage(this.localStorageKey);
        if (Helper.hasValue(languages)) {
            this.currentLanguageSelection = languages;
        }
        this.state = { dialogOpen: false, values: props.values };
    }
    
    private openDialog = () => {
        this.setState({ dialogOpen: true });
    }

    private createDialog = () => {
        return (
            <div>
                <Dialog {...this.dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this.createMultiSelect()}
                        {this.createTextBoxes()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private createMultiSelect = () => {
        let props: MultiSelectProps = this.factory.getDefaultMultiSelectProps();
        props.value = this.currentLanguageSelection;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = (field: { model: string }, value) => {
            this.currentLanguageSelection = value;
            this.setState({});
        };
        props.onDataLoaded = (field: { model: string }, value: any) => { };
        return (
            <FieldInstance label={this.translations["Sprachen.Sprache"]} noHover={true} >
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private createTextBoxes = () => {
        let elemets = [];
        for (let i = 0; i < this.currentLanguageSelection.length; i++) {
            const t = this.currentLanguageSelection[i];
            elemets.push(
                <div key={Helper.getHashCode(`${t.Sprache}_${t.Language}`)} style={{ flexShrink: 0 }}>
                    <FieldInstance label={t.Sprache} noHover={true} >
                        <TextBox {...this.createTextBoxProps(t)} />
                    </FieldInstance>
                </div>
            );
        }
        return elemets;
    }

    private createTextBoxProps = (language: { Language: number, Sprache: string }) => {
        let props = this.factory.getDefaultTextBoxProps();
        props.field.name = language.Language.toString();
        props.onChange = this.handleTextBoxesChances;
        props.value = Helper.getValueOrDefault(this.state.values.find(f => f.Key == language.Language).Value, "");
        return (props);
    }

    handleTextBoxesChances = (field: { model: string, name: string }, value: any) => {
        let id: number = 0;
        for (let i = 0; i < this.state.values.length; i++) {
            if (this.state.values[i].Key.toString() == field.name) {
                id = i;
                break;
            }
        }
        let items = this.state.values;
        items[id].Value = value;
        this.setState({ values: items });
    }

    private createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }

        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }
        return (
            <>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={this.openDialog}>{this.translations["Standard.TranslationLink"]}</label>
                </div>

            </>
        );
    }

    componentDidMount() {
        this.loadTranslations();
    }

    private loadTranslations = () => {
        Helper.getTranslations(["Standard.TranslationLink", "Sprachen.Sprache"]).then((result) => {
            this.translations = result.Data;
            this.setState({});
        });
    }

    render() {
        const link = Helper.hasValue(this.translations) ? this.createLink() : (<></>);
        const dialog = this.state.dialogOpen ? this.createDialog() : <></>;
        return (
            <>
                {link}
                {dialog}
            </>);
    }
}

interface EditNachschlagProps {
    entity: any;
    context: ContextGeneralSettingsApp;
    field: {
        props: {
            tabId: number;
            hardLock: boolean;
            fields: Field[]
        }
    };
}

interface Field {
    field: string;
    name: string;
    onChange?: string;
    renderAsCheckBox?: boolean;
}

interface EditNachschlagState {
    gridData: Nachschlag[];
    dialogOpen: boolean;
    searchedOGrNr: number;
    currentItem: Nachschlag;
    buttons: {
        delete: boolean;
        addToAllMainGroups: boolean;
    }
}

interface TranslationLinkProps {
    onOkClick: (translations: KeyValue[]) => void;
    values: KeyValue[];
    currentLanguage: number;
}

interface TranslationLinkState {
    dialogOpen: boolean;
    values: KeyValue[];
}

interface Nachschlag {
    Id: number;
    Name: string;
    MainGroups: KeyValue[];
    HasAllMainGroups: boolean;
    Translations: KeyValue[];
    IsNew: boolean;
    IsDeletable: boolean;
    FeldInt: number;
}

interface KeyValue {
    Key: number;
    Value: string;
}

interface Columnn {
    field: string,
    title: string,
    width: number,
    template?: string
}
